import { render, staticRenderFns } from "./Navegacao.vue?vue&type=template&id=98c67696&scoped=true&lang=pug"
import script from "./Navegacao.vue?vue&type=script&lang=js"
export * from "./Navegacao.vue?vue&type=script&lang=js"
import style0 from "./Navegacao.styl?vue&type=style&index=0&id=98c67696&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c67696",
  null
  
)

export default component.exports